import React from 'react';
import { Check } from 'lucide-react';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function PaintCorrectionPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Paint Correction',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Thousand Oaks', 'Ventura County', 'Los Angeles'],
    description: 'Professional paint correction and polishing to remove swirl marks, scratches, and oxidation, restoring a mirror-like finish.'
  };
  return <ServicePageLayout title="Paint Correction in Los Angeles & Ventura County" subtitle="Erase years of wear and tear. Our machine polishing process removes swirl marks, scratches, and oxidation to restore a flawless, mirror-like finish." metaDescription="Expert paint correction and polishing in Camarillo, Thousand Oaks, and Ventura County. Remove swirl marks and scratches. Call (818) 381-9905." schema={schema} data-id="element-528">
      <p data-id="element-529">
        Does your car's paint look dull, faded, or covered in a web of fine
        scratches when the sun hits it? These imperfections are known as swirl
        marks, and they are typically caused by improper washing techniques,
        automated car washes, and environmental wear. At Mike's Pro Detail, our{' '}
        <strong data-id="element-530">Paint Correction</strong> service utilizes advanced machine
        polishing techniques to permanently remove these defects, restoring
        clarity, depth, and a brilliant shine to your vehicle's finish. We
        provide this specialized mobile service throughout Camarillo CA,
        Thousand Oaks, and Ventura County.
      </p>

      <h2 data-id="element-531">What is Paint Correction?</h2>
      <p data-id="element-532">
        Paint correction is the mechanical process of leveling the clear coat of
        a vehicle's paintwork to remove sub-surface defects. Unlike waxes or
        glazes that simply "fill in" or hide scratches temporarily, paint
        correction permanently removes them by safely shaving down microscopic
        layers of the clear coat until the surface is perfectly flat and
        reflective.
      </p>

      <h2 data-id="element-533">Defects We Can Remove:</h2>

      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-534">
        <li className="flex items-start" data-id="element-535">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-536" />
          <span data-id="element-537">
            <strong data-id="element-538">Swirl Marks & Spider Webbing:</strong> The circular
            micro-scratches most visible under direct sunlight or streetlights.
          </span>
        </li>
        <li className="flex items-start" data-id="element-539">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-540" />
          <span data-id="element-541">
            <strong data-id="element-542">Light to Medium Scratches:</strong> Scratches that have not
            penetrated entirely through the clear coat down to the base color.
          </span>
        </li>
        <li className="flex items-start" data-id="element-543">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-544" />
          <span data-id="element-545">
            <strong data-id="element-546">Water Spots & Etching:</strong> Mineral deposits from hard
            water or acid rain that have baked into the surface.
          </span>
        </li>
        <li className="flex items-start" data-id="element-547">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-548" />
          <span data-id="element-549">
            <strong data-id="element-550">Oxidation & Fading:</strong> The cloudy, chalky appearance
            caused by prolonged UV exposure and lack of protection.
          </span>
        </li>
        <li className="flex items-start" data-id="element-551">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-552" />
          <span data-id="element-553">
            <strong data-id="element-554">Buffer Trails & Holograms:</strong> Marks left behind by
            inexperienced detailers using rotary polishers incorrectly.
          </span>
        </li>
      </ul>

      <h2 data-id="element-555">Our Multi-Stage Process</h2>
      <p data-id="element-556">
        Depending on the condition of your paint and your desired results, we
        offer different levels of correction. A <strong data-id="element-557">One-Step Polish</strong>{' '}
        is great for newer cars or those needing a light enhancement, removing
        about 50-60% of defects while significantly boosting gloss. A{' '}
        <strong data-id="element-558">Two-Step Correction</strong> involves a heavy compounding stage
        to remove deeper scratches, followed by a refining polish to restore
        maximum clarity, removing 85-95% of defects. Every paint correction
        service begins with a thorough wash, iron decontamination, and clay bar
        treatment to ensure the paint is surgically clean before polishing
        begins.
      </p>

      <h2 data-id="element-559">The Best Mobile Detailing Ventura County Has to Offer</h2>
      <p data-id="element-560">
        Paint correction is an art that requires the right combination of
        machines, pads, compounds, and technique. Doing it wrong can burn
        through the clear coat and cause irreversible damage. When searching for
        "Mobile Auto Detailing Camarillo CA" or "Car Detailing Camarillo" for
        high-end paint restoration, trust the expertise of Mike's Pro Detail. We
        highly recommend pairing our paint correction service with a Ceramic
        Coating to lock in that flawless finish for years to come.
      </p>
    </ServicePageLayout>;
}